import { useCallback, useEffect, useMemo, useState } from "react";
import { PaginationContainer, PaginationItem } from "./styles";

export interface PaginationProps {
  totalCount: number;
  currentPage?: number;
  perPage?: number;
  onNavigate?: (page: number) => void;
}

export const Pagination = ({
  totalCount,
  currentPage = 1,
  perPage = 50,
  onNavigate = () => { }
}: PaginationProps) => {
  const [selectedPage, setSelectedPage] = useState(currentPage)

  const pagesCount = Math.ceil(totalCount / perPage)

  const navigate = useCallback((page: number) => {
    setSelectedPage(page)
    onNavigate(page)
  }, [onNavigate])

  const PagesList = useMemo(() => {
    const activeClassName = "pagination__btn pagination__btn--active btn btn--primary btn--fill text--regular p-0"
    const defaultClassName = "pagination__btn btn btn--primary color-text text--regular p-0"

    const pages = []
    const startIndex = 1
    let endIndex = pagesCount
    // const startIndex = selectedPage > 5 ? selectedPage - 5 : 1
    // let endIndex = selectedPage > 5 ? selectedPage + 5 : 5
    // endIndex = endIndex > pagesCount ? pagesCount : endIndex

    for (let i = startIndex; i <= endIndex; i++) {
      let active = i === selectedPage

      pages.push((
        <span
          className={active ? activeClassName : defaultClassName}
          key={i}
          children={i}
          onClick={() => navigate(i)}
        />
      ))
    }

    return pages
  }, [selectedPage, pagesCount, navigate])

  useEffect(() => {
    setSelectedPage(currentPage)
  }, [currentPage])

  return (
    <PaginationContainer>
      {/*{selectedPage >= 5 && (*/}
      {/*  <PaginationItem children="<<" onClick={() => navigate(1)} />*/}
      {/*)}*/}
      {/*{selectedPage !== 1 && (*/}
      {/*  <PaginationItem children="<" onClick={() => navigate(selectedPage - 1)} />*/}
      {/*)}*/}

      {PagesList}

      {/*{selectedPage !== pagesCount && (*/}
      {/*  <>*/}
      {/*    <PaginationItem children=">" onClick={() => navigate(selectedPage + 1)} />*/}
      {/*    <PaginationItem children=">>" onClick={() => navigate(pagesCount)} />*/}
      {/*  </>*/}
      {/*)}*/}
    </PaginationContainer>
  )
}
